import axios, { AxiosError } from "axios";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { IRhService } from "./rh_service";
import {
  GetFuncionariosRequest,
  GetFuncionariosResponse,
} from "../daos/read/get_funcionarios";
import {
  DeleteFuncionarioRequest,
  DeleteFuncionarioResponse,
} from "../daos/delete/delete_funcionario";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { CepDao, GetCepRequest, GetCepResponse } from "../daos/read/get_cep";
import {
  GetDocumentosRequest,
  GetDocumentosResponse,
} from "../daos/read/get_documentos";
import {
  GetDocumentosEntreguesRequest,
  GetDocumentosEntreguesResponse,
} from "../daos/read/get_documentos_entregues";
import {
  GetDependentesRequest,
  GetDependentesResponse,
} from "../daos/read/get_dependentes";
import {
  GetEventosRequest,
  GetEventosResponse,
} from "../daos/read/get_eventos";
import { GetFeriasRequest, GetFeriasResponse } from "../daos/read/get_ferias";
import {
  GetAfastamentosRequest,
  GetAfastamentosResponse,
} from "../daos/read/get_afastamentos";
import {
  GetItensVerbaDropDownResponse,
  ItemVerbaDropDownDao,
} from "../daos/read/get_itens_verba_dropdown";
import {
  GetMotivosAfastamentoDropDownResponse,
  MotivoAfastamentoDropDownDao,
} from "../daos/read/get_motivos_afastamento_dropdown";
import {
  GetMotivosDemissaoDropDownResponse,
  MotivoDemissaoDropDownDao,
} from "../daos/read/get_motivos_demissao_dropdown";
import {
  GetFuncionarioTreinamentosRequest,
  GetFuncionarioTreinamentosResponse,
} from "../daos/read/get_treinamentos";
import {
  GetAvaliacaoHabilidadesRequest,
  GetAvaliacaoHabilidadesResponse,
} from "../daos/read/get_avaliacao_habilidades";
import {
  GetTreinamentosDropDownResponse,
  TreinamentoDropDownDao,
} from "../daos/read/get_treinamentos_dropdown";
import {
  GetHabilidadeItemsRequest,
  GetHabilidadeItemsResponse,
} from "../daos/read/get_habilidade_items";
import {
  GetHabilidadesDropDownResponse,
  HabilidadeDropDownDao,
} from "../daos/read/get_habilidades_dropdown";
import {
  CreateAfastamentoRequest,
  CreateAfastamentoResponse,
} from "../daos/create/create_afastamento";
import {
  AvaliarTreinamentoRequest,
  AvaliarTreinamentoResponse,
} from "../daos/create/avaliar_treinamento";
import {
  CreateDependenteRequest,
  CreateDependenteResponse,
} from "../daos/create/create_dependente";
import {
  CreateDocumentoRequest,
  CreateDocumentoResponse,
} from "../daos/create/create_documento";
import {
  CreateEventoRequest,
  CreateEventoResponse,
} from "../daos/create/create_evento";
import {
  CreateFeriasRequest,
  CreateFeriasResponse,
} from "../daos/create/create_ferias";
import {
  CreateFuncionarioRequest,
  CreateFuncionarioResponse,
} from "../daos/create/create_funcionario";
import {
  CreateAvaliacaoTreinamentoRequest,
  CreateAvaliacaoTreinamentoResponse,
} from "../daos/create/create_avaliacao_treinamento";
import {
  DeleteAfastamentoRequest,
  DeleteAfastamentoResponse,
} from "../daos/delete/delete_afastamento";
import {
  DeleteAvaliacaoTreinamentoRequest,
  DeleteAvaliacaoTreinamentoResponse,
} from "../daos/delete/delete_avaliacao_treinamento";
import {
  DeleteDependenteRequest,
  DeleteDependenteResponse,
} from "../daos/delete/delete_dependente";
import {
  DeleteDocumentoRequest,
  DeleteDocumentoResponse,
} from "../daos/delete/delete_documento";
import {
  DeleteEventoRequest,
  DeleteEventoResponse,
} from "../daos/delete/delete_evento";
import {
  DeleteFeriasRequest,
  DeleteFeriasResponse,
} from "../daos/delete/delete_ferias";
import {
  DeleteAvaliacaoHabilidadeRequest,
  DeleteAvaliacaoHabilidadeResponse,
} from "../daos/delete/delete_avaliacao_habilidade";
import {
  DeleteAvaliacaoHabilidadeItemRequest,
  DeleteAvaliacaoHabilidadeItemResponse,
} from "../daos/delete/delete_avaliacao_habilidade_item";
import {
  DeleteFuncionarioTreinamentoRequest,
  DeleteFuncionarioTreinamentoResponse,
} from "../daos/delete/delete_funcionario_treinamento";
import {
  UpdateAfastamentoRequest,
  UpdateAfastamentoResponse,
} from "../daos/update/update_afastamento";
import {
  UpdateDependenteRequest,
  UpdateDependenteResponse,
} from "../daos/update/update_dependente";
import {
  UpdateDocumentoRequest,
  UpdateDocumentoResponse,
} from "../daos/update/update_documento";
import {
  UpdateEventoRequest,
  UpdateEventoResponse,
} from "../daos/update/update_evento";
import {
  UpdateFeriasRequest,
  UpdateFeriasResponse,
} from "../daos/update/update_ferias";
import {
  UpdateFuncionarioRequest,
  UpdateFuncionarioResponse,
} from "../daos/update/update_funcionario";
import {
  UpdateAvaliacaoTreinamentoRequest,
  UpdateAvaliacaoTreinamentoResponse,
} from "../daos/update/update_treinamento";
import {
  GetControlePatrimoniosRequest,
  GetControlePatrimoniosResponse,
} from "../daos/read/get_controle_patrimonios";
import {
  EquipamentoDropDownDao,
  GetEquipamentosDropDownResponse,
} from "../daos/read/get_equipamentos_dropdown";
import {
  GetFuncionarioEnderecoByIdRequest,
  GetFuncionarioEnderecoByIdResponse,
} from "../daos/read/get_funcionario_by_id";
import {
  GetCentroCustoSecundariosRequest,
  GetCentroCustoSecundariosResponse,
} from "../daos/read/get_centro_custo_secundarios";
import {
  CreateCentroCustoSecundarioRequest,
  CreateCentroCustoSecundarioResponse,
} from "../daos/create/create_centro_custo_secundario";
import {
  UpdateCentroCustoSecundarioRequest,
  UpdateCentroCustoSecundarioResponse,
} from "../daos/update/update_centro_custo_secundario";
import {
  CreateAvaliacaoHabilidadeRequest,
  CreateAvaliacaoHabilidadeResponse,
} from "../daos/create/create_avaliacao_habilidade";
import {
  CreateAvaliacaoHabilidadeItemRequest,
  CreateAvaliacaoHabilidadeItemResponse,
} from "../daos/create/create_avaliacao_habilidade_item";
import {
  CreateControlePatrimonioRequest,
  CreateControlePatrimonioResponse,
} from "../daos/create/create_controle_patrimonio";
import {
  UpdateAvaliacaoHabilidadeRequest,
  UpdateAvaliacaoHabilidadeResponse,
} from "../daos/update/update_avaliacao_habilidade";
import {
  UpdateAvaliacaoHabilidadeItemRequest,
  UpdateAvaliacaoHabilidadeItemResponse,
} from "../daos/update/update_avaliacao_habilidade_item";
import {
  UpdateControlePatrimonioRequest,
  UpdateControlePatrimonioResponse,
} from "../daos/update/update_controle_patrimonio";
import {
  DeleteCentroCustoSecundarioRequest,
  DeleteCentroCustoSecundarioResponse,
} from "../daos/delete/delete_centro_custo_secundario";
import {
  DeleteControlePatrimonioRequest,
  DeleteControlePatrimonioResponse,
} from "../daos/delete/delete_controle_patrimonio";
import {
  DeleteAllDocumentosRequest,
  DeleteAllDocumentosResponse,
} from "../daos/delete/delete_all_documentos";
import {
  DeleteFuncionarioTreinamentosLoteRequest,
  DeleteFuncionarioTreinamentosLoteResponse,
} from "../daos/delete/delete_funcionario_treinamentos_lote";
import { GetFuncionarioAllDocumentosRequest } from "../daos/read/get_funcionario_all_documentos";
import {
  GetMotivosDemissaoRequest,
  GetMotivosDemissaoResponse,
} from "../daos/read/get_motivos_demissao";
import {
  CreateMotivosDemissaoRequest,
  CreateMotivosDemissaoResponse,
} from "../daos/create/create_motivo_demissao";
import {
  UpdateMotivosDemissaoRequest,
  UpdateMotivosDemissaoResponse,
} from "../daos/update/update_motivo_demissao";
import {
  DeleteMotivosDemissaoRequest,
  DeleteMotivosDemissaoResponse,
} from "../daos/delete/delete_motivo_demissao";
import {
  GetFuncionarioAssinaturasRequest,
  GetFuncionarioAssinaturasResponse,
} from "../daos/read/get_funcionario_assinaturas";
import {
  CreateFuncionarioAssinaturaRequest,
  CreateFuncionarioAssinaturaResponse,
} from "../daos/create/create_funcionario_assinatura";
import {
  UpdateFuncionarioAssinaturaRequest,
  UpdateFuncionarioAssinaturaResponse,
} from "../daos/update/update_funcionario_assinatura";
import {
  DeleteFuncionarioAssinaturaRequest,
  DeleteFuncionarioAssinaturaResponse,
} from "../daos/delete/delete_funcionario_assinatura";
import {
  GetMotivosAfastamentoRequest,
  GetMotivosAfastamentoResponse,
} from "../daos/read/get_motivos_afastamento";
import {
  CreateMotivosAfastamentoRequest,
  CreateMotivosAfastamentoResponse,
} from "../daos/create/create_motivo_afastamento";
import {
  DeleteMotivosAfastamentoRequest,
  DeleteMotivosAfastamentoResponse,
} from "../daos/delete/delete_motivo_afastamento";
import {
  UpdateMotivosAfastamentoRequest,
  UpdateMotivosAfastamentoResponse,
} from "../daos/update/update_motivo_afastamento";
import {
  GetAllCargoRequest,
  GetAllCargoResponse,
} from "../daos/read/get_all_cargo";
import {
  DeleteCargoRequest,
  DeleteCargoResponse,
} from "../daos/delete/delete_cargo";
import {
  GetCargoHabilidadesRequest,
  GetCargoHabilidadesResponse,
} from "../daos/read/get_cargo_habilidades";
import {
  GetCargoTreinamentosRequest,
  GetCargoTreinamentosResponse,
} from "../daos/read/get_cargo_treinamentos";
import {
  GetCargoByIdRequest,
  GetCargoByIdResponse,
} from "../daos/read/get_cargo_by_id";
import {
  CreateCargoRequest,
  CreateCargoResponse,
} from "../daos/create/create_cargo";
import {
  UpdateCargoRequest,
  UpdateCargoResponse,
} from "../daos/update/update_cargo";
import { CopyCargoRequest, CopyCargoResponse } from "../daos/create/copy_cargo";
import {
  GetAllTreinamentoRequest,
  GetAllTreinamentoResponse,
} from "../daos/read/get_all_treinamento";
import {
  CreateTreinamentoRequest,
  CreateTreinamentoResponse,
} from "../daos/create/create_treinamento";
import {
  DeleteTreinamentoRequest,
  DeleteTreinamentoResponse,
} from "../daos/delete/delete_treinamento";
import {
  UpdateTreinamentoRequest,
  UpdateTreinamentoResponse,
} from "../daos/read/update_treinamento";
import {
  CopyTreinamentoRequest,
  CopyTreinamentoResponse,
} from "../daos/create/copy_treinamento";
import {
  GetAllCargoTreinamentoCargoRequest,
  GetAllCargoTreinamentoCargoResponse,
} from "../daos/read/get_all_cargo_treinamento_cargo";
import {
  GetAllTreinamentoTreinamentoCargoRequest,
  GetAllTreinamentoTreinamentoCargoResponse,
} from "../daos/read/get_all_treinamento_treinamento_cargo";
import {
  SaveCargoTreinamentoRequest,
  SaveCargoTreinamentoResponse,
} from "../daos/create/save_cargo_treinamento";
import {
  InativarTreinamentosRequest,
  InativarTreinamentosResponse,
} from "../daos/read/inativar_treinamentos";
import { GetFuncionarioSetoresDropDownResponse } from "../daos/read/get_funcionario_setores_dropdown";
import { GetFuncionarioFiliaisDropDownResponse } from "../daos/read/get_funcionario_filiais_dropdown";
import { GetFuncionarioNomesDropDownResponse } from "../daos/read/get_funcionario_nomes_dropdown";
import {
  CreateHabilidadeRequest,
  CreateHabilidadeResponse,
} from "../daos/create/create_habilidade";
import {
  DeleteHabilidadeRequest,
  DeleteHabilidadeResponse,
} from "../daos/delete/delete_habilidade";
import {
  GetAllHabilidadeRequest,
  GetAllHabilidadeResponse,
} from "../daos/read/get_all_habilidade";
import {
  UpdateHabilidadeRequest,
  UpdateHabilidadeResponse,
} from "../daos/update/update_habilidade";
import {
  GetAllCargoHabilidadeCargoRequest,
  GetAllCargoHabilidadeCargoResponse,
} from "../daos/read/get_all_cargo_habilidade_cargo";
import {
  GetAllHabilidadeHabilidadeCargoRequest,
  GetAllHabilidadeHabilidadeCargoResponse,
} from "../daos/read/get_all_habilidade_habilidade_cargo";
import {
  SaveCargoHabilidadeRequest,
  SaveCargoHabilidadeResponse,
} from "../daos/create/save_cargo_habilidade";
import {
  GetAllAvaliacaoTreinamentoLoteRequest,
  GetAllAvaliacaoTreinamentoLoteResponse,
} from "../daos/read/get_all_avaliacao_treinamento_lote";
import {
  AvaliarTreinamentoLoteRequest,
  AvaliarTreinamentoLoteResponse,
} from "../daos/create/avaliar_treinamento_lote";
import {
  GetAllTreinamentoFuncionarioRequest,
  GetAllTreinamentoFuncionarioResponse,
} from "../daos/read/get_all_treinamento_funcionario";
import {
  SaveTreinamentoFuncionarioRequest,
  SaveTreinamentoFuncionarioResponse,
} from "../daos/create/save_treinamento_funcionario";
import {
  GetAllTreinamentoFuncionarioDataRequest,
  GetAllTreinamentoFuncionarioDataResponse,
} from "../daos/read/get_all_treinamento_funcionario_data";
import {
  GetAllTreinamentoFuncionarioAssinaturaRequest,
  GetAllTreinamentoFuncionarioAssinaturaResponse,
} from "../daos/read/get_all_treinamento_funcionario_assinatura";
import {
  GetAllTreinamentoFuncionarioInstrutorRequest,
  GetAllTreinamentoFuncionarioInstrutorResponse,
} from "../daos/read/get_all_treinamento_funcionario_instrutor";
import {
  GetAllTreinamentoFuncionarioLocalRequest,
  GetAllTreinamentoFuncionarioLocalResponse,
} from "../daos/read/get_all_treinamento_funcionario_local";
import {
  GetAllFolhaPagamentoRequest,
  GetAllFolhaPagamentoResponse,
} from "../daos/read/get_all_folha_pagamento";
import {
  CreateFolhaPagamentoRequest,
  CreateFolhaPagamentoResponse,
} from "../daos/create/create_folha_pagamento";
import {
  UpdateFolhaPagamentoRequest,
  UpdateFolhaPagamentoResponse,
} from "../daos/update/update_folha_pagamento";
import {
  DeleteFolhaPagamentoRequest,
  DeleteFolhaPagamentoResponse,
} from "../daos/delete/delete_folha_pagamento";
import {
  CopyFolhaPagamentoRequest,
  CopyFolhaPagamentoResponse,
} from "../daos/create/copy_folha_pagamento";
import {
  GetAllFolhaPagamentoItensRequest,
  GetAllFolhaPagamentoItensResponse,
} from "../daos/read/get_all_folha_pagamento_itens";
import {
  GetFolhaPagamentoRequest,
  GetFolhaPagamentoResponse,
} from "../daos/read/get_folha_pagamento";
import {
  GetSubcontasDropDownRequest,
  GetSubcontasDropDownResponse,
} from "../daos/read/get_subcontas_dropdown";
import {
  CreateItemFolhaPagamentoRequest,
  CreateItemFolhaPagamentoResponse,
} from "../daos/create/create_item_folha_pagamento";
import {
  DeleteItemFolhaPagamentoRequest,
  DeleteItemFolhaPagamentoResponse,
} from "../daos/delete/delete_item_folha_pagamento";
import {
  UpdateItemFolhaPagamentoRequest,
  UpdateItemFolhaPagamentoResponse,
} from "../daos/update/update_item_folha_pagamento";
import {
  GetFolhaPagamentoDetalheRequest,
  GetFolhaPagamentoDetalheResponse,
} from "../daos/read/get_folha_pagamento_detalhe";
import {
  GetAllItemFolhaPagamentoVerbaRequest,
  GetAllItemFolhaPagamentoVerbaResponse,
} from "../daos/read/get_all_item_folha_pagamento_verba";
import {
  GetItemFolhaPagamentoRequest,
  GetItemFolhaPagamentoResponse,
} from "../daos/read/get_item_folha_pagamento";
import {
  CreateItemFolhaPagamentoVerbaRequest,
  CreateItemFolhaPagamentoVerbaResponse,
} from "../daos/create/create_item_folha_pagamento_verba";
import {
  GetAllItemVerbaFuncionarioDropDownRequest,
  GetAllItemVerbaFuncionarioDropDownResponse,
} from "../daos/read/get_all_item_verba_funcionario_drop_down";
import {
  UpdateItemFolhaPagamentoVerbaRequest,
  UpdateItemFolhaPagamentoVerbaResponse,
} from "../daos/update/update_item_folha_pagamento_verba";
import {
  DeleteItemFolhaPagamentoVerbaRequest,
  DeleteItemFolhaPagamentoVerbaResponse,
} from "../daos/delete/delete_item_folha_pagamento_verba";
import {
  GetFolhaPagamentoDropDownRequest,
  GetFolhaPagamentoDropDownResponse,
} from "../daos/read/get_folha_pagamento_drop_down";
import {
  GetBancoPagamentoDropDownRequest,
  GetBancoPagamentoDropDownResponse,
} from "../daos/read/get_banco_pagamento_drop_down";
import {
  GetFiltroFolhaPagamentoRequest,
  GetFiltroFolhaPagamentoResponse,
} from "../daos/read/get_filtro_folha_pagamento";
import {
  CreateFiltroFolhaPagamentoRequest,
  CreateFiltroFolhaPagamentoResponse,
} from "../daos/create/create_filtro_folha_pagamento";
import {
  GetFolhaPagamentoDetalhadaDropDownRequest,
  GetFolhaPagamentoDetalhadaDropDownResponse,
} from "../daos/read/get_folha_pagamento_detalhada_drop_down";
import {
  GetAllVerbaPagamentoRequest,
  GetAllVerbaPagamentoResponse,
} from "../daos/read/get_all_verba_pagamento";
import {
  DeleteVerbaPagamentoRequest,
  DeleteVerbaPagamentoResponse,
} from "../daos/delete/delete_verba_pagamento";
import {
  CreateVerbaPagamentoRequest,
  CreateVerbaPagamentoResponse,
} from "../daos/create/create_verba_pagamento";
import {
  UpdateVerbaPagamentoRequest,
  UpdateVerbaPagamentoResponse,
} from "../daos/update/update_verba_pagamento";
import {
  GetFuncionarioAssinaturaDropDownRequest,
  GetFuncionarioAssinaturaDropDownResponse,
} from "../daos/read/get_funcionario_assinatura_drop_down";
import {
  AlterarCentroCustoFuncionariosRequest,
  AlterarCentroCustoFuncionariosResponse,
} from "../daos/update/alterar_centro_custo_funcionarios";
import { DownloadFuncionarioDocumentoByIdRequest } from "../daos/read/download_funcionario_documento_by_id";
import {
  GetDashboardRhInformationRequest,
  GetDashboardRhInformationResponse,
} from "../daos/read/get_dashboard_rh_information";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";
import { GetFuncionarioImageByIdRequest } from "../daos/read/get_funcionario_image_by_id";
import {
  DeleteFuncionarioImageByIdRequest,
  DeleteFuncionarioImageByIdResponse,
} from "../daos/delete/delete_funcionario_image_by_id";
import {
  CopyFuncionarioRequest,
  CopyFuncionarioResponse,
} from "../daos/create/copy_funcionario";
import { DownloadControlePatrimonioByIdRequest } from "../daos/read/download_controle_patrimonio_by_id";
import { DownloadFuncionarioAssinaturaRequest } from "../daos/read/download_funcionario_assinatura";
import {
  CreateBiometriaFacialRequest,
  CreateBiometriaFacialResponse,
} from "../daos/create/create_biometria_facial";
import {
  CreateBiometriaFacialFuncionarioRequest,
  CreateBiometriaFacialFuncionarioResponse,
} from "../daos/create/create_biometria_facial_funcioanario";
import {
  GetBiometriaFacialRequest,
  GetBiometriaFacialResponse,
} from "../daos/read/get_biometria_facial";
import {
  InativarBiometriaFacialRequest,
  InativarBiometriaFacialResponse,
} from "../daos/delete/delete_biometria_facial";
import { GetBiometriaFacialVisualizarRequest } from "../daos/read/get_biometria_facial_visualizar";
import { CreateTermoBiometriaRequest, CreateTermoBiometriaResponse } from "../daos/create/create_termo_biometria";
import { GenerateCertificateRequest } from "../daos/read/generate_certificate";
import { JobStatusResponse } from "../../../../common/domain/models/job_status_response";

/**
 * RhService
 */

export class RhService implements IRhService {
  async getHabilidadesDropDown(): Promise<GetHabilidadesDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/rh/habilidades/dropdown`);
      const response = handleAxiosResponse<HabilidadeDropDownDao[]>(result);
      return { items: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getMotivosDemissaoDropDown(): Promise<GetMotivosDemissaoDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/motivo-demissao/dropdown`,
      );
      const response = handleAxiosResponse<MotivoDemissaoDropDownDao[]>(result);
      return { items: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getTreinamentosDropDown(): Promise<GetTreinamentosDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/rh/treinamentos/dropdown`);
      const response = handleAxiosResponse<TreinamentoDropDownDao[]>(result);
      return { items: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getMotivosAfastamentoDropDown(): Promise<GetMotivosAfastamentoDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/motivo-afastamento/dropdown`,
      );
      const response =
        handleAxiosResponse<MotivoAfastamentoDropDownDao[]>(result);
      return { items: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getItensVerbaDropDown(): Promise<GetItensVerbaDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/rh/item-verba/dropdown`);
      const response = handleAxiosResponse<ItemVerbaDropDownDao[]>(result);
      return { items: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getEquipamentosDropDown(): Promise<GetEquipamentosDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/rh/equipamentos/dropdown`);
      const response = handleAxiosResponse<EquipamentoDropDownDao[]>(result);
      return { items: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionarioSetoresDropDown(): Promise<GetFuncionarioSetoresDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/funcionario-setores/dropdown`,
      );
      const response =
        handleAxiosResponse<GetFuncionarioSetoresDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionarioNomesDropDown(): Promise<GetFuncionarioNomesDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/funcionario-nomes/dropdown`,
      );
      const response =
        handleAxiosResponse<GetFuncionarioNomesDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllItemVerbaFuncionarioDropDown(
    request: GetAllItemVerbaFuncionarioDropDownRequest,
  ): Promise<GetAllItemVerbaFuncionarioDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/item-verba-funcionario/dropdown/${request.idItemVerbaFuncionario}`,
      );
      const response =
        handleAxiosResponse<GetAllItemVerbaFuncionarioDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionarioFiliaisDropDown(): Promise<GetFuncionarioFiliaisDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/funcionario-filiais/dropdown`,
      );
      const response =
        handleAxiosResponse<GetFuncionarioFiliaisDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFolhaPagamentoDropDown(
    request: GetFolhaPagamentoDropDownRequest,
  ): Promise<GetFolhaPagamentoDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/folha-pagamento/dropdown`,
      );
      const response =
        handleAxiosResponse<GetFolhaPagamentoDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFolhaPagamentoDetalhadaDropDown(
    request: GetFolhaPagamentoDetalhadaDropDownRequest,
  ): Promise<GetFolhaPagamentoDetalhadaDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/folha-pagamento-detalhada/dropdown`,
      );
      const response =
        handleAxiosResponse<GetFolhaPagamentoDetalhadaDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getBancoPagamentoDropDown(
    request: GetBancoPagamentoDropDownRequest,
  ): Promise<GetBancoPagamentoDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/banco-pagamento/dropdown`,
      );
      const response =
        handleAxiosResponse<GetBancoPagamentoDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getSubcontasDropDown(
    request: GetSubcontasDropDownRequest,
  ): Promise<GetSubcontasDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/subcontas/dropdown`,
        request,
      );
      const response =
        handleAxiosResponse<GetSubcontasDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionarioAssinaturaDropDown(
    request: GetFuncionarioAssinaturaDropDownRequest,
  ): Promise<GetFuncionarioAssinaturaDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/funcionario/assinatura/dropdown`,
        request,
      );
      const response =
        handleAxiosResponse<GetFuncionarioAssinaturaDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getCep(request: GetCepRequest): Promise<GetCepResponse> {
    try {
      const result = await axios.get(
        `https://viacep.com.br/ws/${request.cep}/json/`,
      );
      const cep = handleAxiosResponse<CepDao>(result);
      return { cep };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionarios(
    request: GetFuncionariosRequest,
  ): Promise<GetFuncionariosResponse> {
    try {
      const result = await axiosInstance({}).post(`/rh/funcionarios`, request);
      const response = handleAxiosResponse<GetFuncionariosResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getDocumentos(
    request: GetDocumentosRequest,
  ): Promise<GetDocumentosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/documentos`,
        request,
      );
      const response = handleAxiosResponse<GetDocumentosResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getDocumentosEntregues(
    request: GetDocumentosEntreguesRequest,
  ): Promise<GetDocumentosEntreguesResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/documentos-entregues`,
        request,
      );
      const response =
        handleAxiosResponse<GetDocumentosEntreguesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionarioTreinamentos(
    request: GetFuncionarioTreinamentosRequest,
  ): Promise<GetFuncionarioTreinamentosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/treinamentos`,
        request,
      );
      const response =
        handleAxiosResponse<GetFuncionarioTreinamentosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAvaliacaoHabilidades(
    request: GetAvaliacaoHabilidadesRequest,
  ): Promise<GetAvaliacaoHabilidadesResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/habilidades`,
        request,
      );
      const response =
        handleAxiosResponse<GetAvaliacaoHabilidadesResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getDependentes(
    request: GetDependentesRequest,
  ): Promise<GetDependentesResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/dependentes`,
        request,
      );
      const response = handleAxiosResponse<GetDependentesResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getEventos(request: GetEventosRequest): Promise<GetEventosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/eventos`,
        request,
      );
      const response = handleAxiosResponse<GetEventosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFerias(request: GetFeriasRequest): Promise<GetFeriasResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/ferias`,
        request,
      );
      const response = handleAxiosResponse<GetFeriasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAfastamentos(
    request: GetAfastamentosRequest,
  ): Promise<GetAfastamentosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/afastamentos`,
        request,
      );
      const response = handleAxiosResponse<GetAfastamentosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getHabilidadeItems(
    request: GetHabilidadeItemsRequest,
  ): Promise<GetHabilidadeItemsResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/habilidades/items`,
        request,
      );
      const response = handleAxiosResponse<GetHabilidadeItemsResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getControlePatrimonios(
    request: GetControlePatrimoniosRequest,
  ): Promise<GetControlePatrimoniosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/controle-patrimonios`,
        request,
      );
      const response =
        handleAxiosResponse<GetControlePatrimoniosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getCentroCustoSecundarios(
    request: GetCentroCustoSecundariosRequest,
  ): Promise<GetCentroCustoSecundariosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/centro-custo-secundario`,
        request,
      );
      const response =
        handleAxiosResponse<GetCentroCustoSecundariosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createFuncionario(
    request: CreateFuncionarioRequest,
  ): Promise<CreateFuncionarioResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/create`,
        formData,
        options,
      );
      const response = handleAxiosResponse<CreateFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createCentroCustoSecundario(
    request: CreateCentroCustoSecundarioRequest,
  ): Promise<CreateCentroCustoSecundarioResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/centro-custo-secundario/create`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<CreateCentroCustoSecundarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createDependente(
    request: CreateDependenteRequest,
  ): Promise<CreateDependenteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/dependentes/create`,
        request,
      );
      const response = handleAxiosResponse<CreateDependenteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createEvento(
    request: CreateEventoRequest,
  ): Promise<CreateEventoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/eventos/create`,
        request,
      );
      const response = handleAxiosResponse<CreateEventoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createFerias(
    request: CreateFeriasRequest,
  ): Promise<CreateFeriasResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/ferias/create`,
        request,
      );
      const response = handleAxiosResponse<CreateFeriasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createAfastamento(
    request: CreateAfastamentoRequest,
  ): Promise<CreateAfastamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/afastamentos/create`,
        request,
      );
      const response = handleAxiosResponse<CreateAfastamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createDocumento(
    request: CreateDocumentoRequest,
  ): Promise<CreateDocumentoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/documentos/create`,
        formData,
        options,
      );
      const response = handleAxiosResponse<CreateDocumentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createAvaliacaoTreinamento(
    request: CreateAvaliacaoTreinamentoRequest,
  ): Promise<CreateAvaliacaoTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/treinamentos/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateAvaliacaoTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createAvaliacaoHabilidade(
    request: CreateAvaliacaoHabilidadeRequest,
  ): Promise<CreateAvaliacaoHabilidadeResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/habilidades/avaliacao/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateAvaliacaoHabilidadeResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createAvaliacaoHabilidadeItem(
    request: CreateAvaliacaoHabilidadeItemRequest,
  ): Promise<CreateAvaliacaoHabilidadeItemResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/habilidades/avaliacao/items/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateAvaliacaoHabilidadeItemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createControlePatrimonio(
    request: CreateControlePatrimonioRequest,
  ): Promise<CreateControlePatrimonioResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/controle-patrimonios/create`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<CreateAvaliacaoTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async avaliarTreinamento(
    request: AvaliarTreinamentoRequest,
  ): Promise<AvaliarTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/treinamentos/avaliar`,
        request,
      );
      const response = handleAxiosResponse<AvaliarTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateFuncionario(
    request: UpdateFuncionarioRequest,
  ): Promise<UpdateFuncionarioResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/update`,
        formData,
        options,
      );
      const response = handleAxiosResponse<UpdateFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateCentroCustoSecundario(
    request: UpdateCentroCustoSecundarioRequest,
  ): Promise<UpdateCentroCustoSecundarioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/centro-custo-secundario/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateCentroCustoSecundarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateDependente(
    request: UpdateDependenteRequest,
  ): Promise<UpdateDependenteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/dependentes/update`,
        request,
      );
      const response = handleAxiosResponse<CreateDependenteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateEvento(
    request: UpdateEventoRequest,
  ): Promise<UpdateEventoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/eventos/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateEventoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateFerias(
    request: UpdateFeriasRequest,
  ): Promise<UpdateFeriasResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/ferias/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateFeriasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateAfastamento(
    request: UpdateAfastamentoRequest,
  ): Promise<UpdateAfastamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/afastamentos/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateAfastamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateDocumento(
    request: UpdateDocumentoRequest,
  ): Promise<UpdateDocumentoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/documentos/update`,
        formData,
        options,
      );
      const response = handleAxiosResponse<UpdateDocumentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateAvaliacaoTreinamento(
    request: UpdateAvaliacaoTreinamentoRequest,
  ): Promise<UpdateAvaliacaoTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/treinamentos/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateAvaliacaoTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateAvaliacaoHabilidade(
    request: UpdateAvaliacaoHabilidadeRequest,
  ): Promise<UpdateAvaliacaoHabilidadeResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/habilidades/avaliacao/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateAvaliacaoHabilidadeResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateAvaliacaoHabilidadeItem(
    request: UpdateAvaliacaoHabilidadeItemRequest,
  ): Promise<UpdateAvaliacaoHabilidadeItemResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/habilidades/avaliacao/items/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateAvaliacaoHabilidadeItemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateControlePatrimonio(
    request: UpdateControlePatrimonioRequest,
  ): Promise<UpdateControlePatrimonioResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/controle-patrimonios/update`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<UpdateAvaliacaoTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionarioEnderecoById(
    request: GetFuncionarioEnderecoByIdRequest,
  ): Promise<GetFuncionarioEnderecoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/funcionarios/${request.idFuncionario}`,
      );
      const response =
        handleAxiosResponse<GetFuncionarioEnderecoByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteFuncionario(
    request: DeleteFuncionarioRequest,
  ): Promise<DeleteFuncionarioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/delete`,
        request,
      );
      const response = handleAxiosResponse<DeleteFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteCentroCustoSecundario(
    request: DeleteCentroCustoSecundarioRequest,
  ): Promise<DeleteCentroCustoSecundarioResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/centro-custo-secundario/delete/${request.idCentroCustoSecundario}`,
      );
      const response =
        handleAxiosResponse<DeleteCentroCustoSecundarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteDependente(
    request: DeleteDependenteRequest,
  ): Promise<DeleteDependenteResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/dependentes/delete/${request.idDependente}`,
      );
      const response = handleAxiosResponse<DeleteDependenteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteEvento(
    request: DeleteEventoRequest,
  ): Promise<DeleteEventoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/eventos/delete/${request.idEvento}`,
      );
      const response = handleAxiosResponse<DeleteEventoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteFerias(
    request: DeleteFeriasRequest,
  ): Promise<DeleteFeriasResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/ferias/delete/${request.idFerias}`,
      );
      const response = handleAxiosResponse<DeleteFeriasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteAfastamento(
    request: DeleteAfastamentoRequest,
  ): Promise<DeleteAfastamentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/afastamentos/delete/${request.idAfastamento}`,
      );
      const response = handleAxiosResponse<DeleteFeriasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteDocumento(
    request: DeleteDocumentoRequest,
  ): Promise<DeleteDocumentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/documentos/delete/${request.idDocumento}`,
      );
      const response = handleAxiosResponse<DeleteDocumentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteAllDocumentos(
    request: DeleteAllDocumentosRequest,
  ): Promise<DeleteAllDocumentosResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/documentos/delete-all/${request.idFuncionario}`,
      );
      const response = handleAxiosResponse<DeleteAllDocumentosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteFuncionarioTreinamento(
    request: DeleteFuncionarioTreinamentoRequest,
  ): Promise<DeleteFuncionarioTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/treinamentos/delete/${request.idFuncionarioTreinamento}`,
      );
      const response =
        handleAxiosResponse<DeleteFuncionarioTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteFuncionarioTreinamentosLote(
    request: DeleteFuncionarioTreinamentosLoteRequest,
  ): Promise<DeleteFuncionarioTreinamentosLoteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/treinamentos/delete/lote`,
        request,
      );
      const response =
        handleAxiosResponse<DeleteFuncionarioTreinamentosLoteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteAvaliacaoTreinamento(
    request: DeleteAvaliacaoTreinamentoRequest,
  ): Promise<DeleteAvaliacaoTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/treinamentos/avaliacao/delete/${request.idAvaliacaoTreinamento}`,
      );
      const response =
        handleAxiosResponse<DeleteAvaliacaoTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteAvaliacaoHabilidade(
    request: DeleteAvaliacaoHabilidadeRequest,
  ): Promise<DeleteAvaliacaoHabilidadeResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/habilidades/avaliacao/delete/${request.idAvaliacaoHabilidade}`,
      );
      const response =
        handleAxiosResponse<DeleteAvaliacaoHabilidadeResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteAvaliacaoHabilidadeItem(
    request: DeleteAvaliacaoHabilidadeItemRequest,
  ): Promise<DeleteAvaliacaoHabilidadeItemResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/habilidades/avaliacao/items/delete/${request.idAvaliacaoHabilidadeItem}`,
      );
      const response =
        handleAxiosResponse<DeleteAvaliacaoHabilidadeItemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteControlePatrimonio(
    request: DeleteControlePatrimonioRequest,
  ): Promise<DeleteControlePatrimonioResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/controle-patrimonios/delete/${request.idControlePatrimonio}`,
      );
      const response =
        handleAxiosResponse<DeleteAvaliacaoHabilidadeItemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionariosAllDocumentos(request: GetFuncionarioAllDocumentosRequest): Promise<JobStatusResponse> {
    try {
      const result = await axiosInstance({}).get(`/rh/funcionarios/documentos/all/download/${request.idFuncionario}`);
      const response = handleAxiosResponse<JobStatusResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getMotivosDemissao(
    request: GetMotivosDemissaoRequest,
  ): Promise<GetMotivosDemissaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/motivos-demissao`,
        request,
      );
      const response = handleAxiosResponse<GetMotivosDemissaoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createMotivoDemissao(
    request: CreateMotivosDemissaoRequest,
  ): Promise<CreateMotivosDemissaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/motivos-demissao/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateMotivosDemissaoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateMotivoDemissao(
    request: UpdateMotivosDemissaoRequest,
  ): Promise<UpdateMotivosDemissaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/motivos-demissao/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateMotivosDemissaoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteMotivoDemissao(
    request: DeleteMotivosDemissaoRequest,
  ): Promise<DeleteMotivosDemissaoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/motivos-demissao/delete/${request.idMotivoDemissao}`,
      );
      const response =
        handleAxiosResponse<UpdateMotivosDemissaoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAssinaturas(
    request: GetFuncionarioAssinaturasRequest,
  ): Promise<GetFuncionarioAssinaturasResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/assinaturas`,
        request,
      );
      const response =
        handleAxiosResponse<GetFuncionarioAssinaturasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createFuncionarioAssinatura(
    request: CreateFuncionarioAssinaturaRequest,
  ): Promise<CreateFuncionarioAssinaturaResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/assinaturas/create`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<CreateFuncionarioAssinaturaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateFuncionarioAssinatura(
    request: UpdateFuncionarioAssinaturaRequest,
  ): Promise<UpdateFuncionarioAssinaturaResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/assinaturas/update`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<UpdateFuncionarioAssinaturaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteFuncionarioAssinatura({
    idFuncionarioAssinatura,
  }: DeleteFuncionarioAssinaturaRequest): Promise<DeleteFuncionarioAssinaturaResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/assinaturas/${idFuncionarioAssinatura}/delete`,
      );
      const response =
        handleAxiosResponse<DeleteFuncionarioAssinaturaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getMotivosAfastamento(
    request: GetMotivosAfastamentoRequest,
  ): Promise<GetMotivosAfastamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/motivos-afastamento`,
        request,
      );
      const response =
        handleAxiosResponse<GetMotivosAfastamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createMotivoAfastamento(
    request: CreateMotivosAfastamentoRequest,
  ): Promise<CreateMotivosAfastamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/motivos-afastamento/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateMotivosAfastamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateMotivoAfastamento(
    request: UpdateMotivosAfastamentoRequest,
  ): Promise<UpdateMotivosAfastamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/motivos-afastamento/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateMotivosAfastamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteMotivoAfastamento(
    request: DeleteMotivosAfastamentoRequest,
  ): Promise<DeleteMotivosAfastamentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/motivos-afastamento/delete/${request.idMotivoAfastamento}`,
      );
      const response =
        handleAxiosResponse<UpdateMotivosAfastamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createCargo(request: CreateCargoRequest): Promise<CreateCargoResponse> {
    try {
      const result = await axiosInstance({}).post(`/rh/cargos/create`, request);
      const response = handleAxiosResponse<CreateCargoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateCargo(request: UpdateCargoRequest): Promise<UpdateCargoResponse> {
    try {
      const result = await axiosInstance({}).post(`/rh/cargos/update`, request);
      const response = handleAxiosResponse<UpdateCargoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copyCargo(request: CopyCargoRequest): Promise<CopyCargoResponse> {
    try {
      const result = await axiosInstance({}).post(`/rh/cargos/copy`, request);
      const response = handleAxiosResponse<UpdateCargoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllCargo(request: GetAllCargoRequest): Promise<GetAllCargoResponse> {
    try {
      const result = await axiosInstance({}).post(`/rh/cargos`, request);
      const response = handleAxiosResponse<GetAllCargoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getCargoTreinamentos(
    request: GetCargoTreinamentosRequest,
  ): Promise<GetCargoTreinamentosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/cargos/treinamentos`,
        request,
      );
      const response =
        handleAxiosResponse<GetCargoTreinamentosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getCargoHabilidades(
    request: GetCargoHabilidadesRequest,
  ): Promise<GetCargoHabilidadesResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/cargos/habilidades`,
        request,
      );
      const response = handleAxiosResponse<GetCargoHabilidadesResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getCargoById(
    request: GetCargoByIdRequest,
  ): Promise<GetCargoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/cargos/${request.idCargo}`,
      );
      const response = handleAxiosResponse<GetCargoByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteCargo(request: DeleteCargoRequest): Promise<DeleteCargoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/cargos/delete/${request.idCargo}`,
      );
      const response = handleAxiosResponse<DeleteCargoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllTreinamentos(
    request: GetAllTreinamentoRequest,
  ): Promise<GetAllTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(`/rh/treinamentos`, request);
      const response = handleAxiosResponse<GetAllTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createTreinamento(
    request: CreateTreinamentoRequest,
  ): Promise<CreateTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/treinamentos/create`,
        request,
      );
      const response = handleAxiosResponse<CreateTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateTreinamento(
    request: UpdateTreinamentoRequest,
  ): Promise<UpdateTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/treinamentos/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteTreinamento(
    request: DeleteTreinamentoRequest,
  ): Promise<DeleteTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/treinamentos/delete/${request.idTreinamento}`,
      );
      const response = handleAxiosResponse<DeleteTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copyTreinamento(
    request: CopyTreinamentoRequest,
  ): Promise<CopyTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/treinamentos/copy`,
        request,
      );
      const response = handleAxiosResponse<CopyTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async inativarTreinamentos(
    request: InativarTreinamentosRequest,
  ): Promise<InativarTreinamentosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/treinamentos/inativar`,
        request,
      );
      const response =
        handleAxiosResponse<InativarTreinamentosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllCargoTreinamentoCargo(
    request: GetAllCargoTreinamentoCargoRequest,
  ): Promise<GetAllCargoTreinamentoCargoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/treinamentos-cargos/cargos`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllCargoTreinamentoCargoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllTreinamentoTreinamentoCargo(
    request: GetAllTreinamentoTreinamentoCargoRequest,
  ): Promise<GetAllTreinamentoTreinamentoCargoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/treinamentos-cargos/treinamentos`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllTreinamentoTreinamentoCargoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async saveCargoTreinamento(
    request: SaveCargoTreinamentoRequest,
  ): Promise<SaveCargoTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/treinamentos-cargos/save`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllTreinamentoTreinamentoCargoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllHabilidade(
    request: GetAllHabilidadeRequest,
  ): Promise<GetAllHabilidadeResponse> {
    try {
      const result = await axiosInstance({}).post(`/rh/habilidades`, request);
      const response = handleAxiosResponse<GetAllHabilidadeResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createHabilidade(
    request: CreateHabilidadeRequest,
  ): Promise<CreateHabilidadeResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/habilidades/create`,
        request,
      );
      const response = handleAxiosResponse<CreateHabilidadeResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateHabilidade(
    request: UpdateHabilidadeRequest,
  ): Promise<UpdateHabilidadeResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/habilidades/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateHabilidadeResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteHabilidade(
    request: DeleteHabilidadeRequest,
  ): Promise<DeleteHabilidadeResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/habilidades/delete/${request.idHabilidade}`,
      );
      const response = handleAxiosResponse<DeleteHabilidadeResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllHabilidadeHabilidadeCargo(
    request: GetAllHabilidadeHabilidadeCargoRequest,
  ): Promise<GetAllHabilidadeHabilidadeCargoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/habilidade-cargos/habilidades`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllHabilidadeHabilidadeCargoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllCargoHabilidadeCargo(
    request: GetAllCargoHabilidadeCargoRequest,
  ): Promise<GetAllCargoHabilidadeCargoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/habilidade-cargos/cargos`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllCargoHabilidadeCargoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async saveCargoHabilidade(
    request: SaveCargoHabilidadeRequest,
  ): Promise<SaveCargoHabilidadeResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/habilidade-cargos/save`,
        request,
      );
      const response = handleAxiosResponse<SaveCargoHabilidadeResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllAvaliacaoTreinamentoLote(
    request: GetAllAvaliacaoTreinamentoLoteRequest,
  ): Promise<GetAllAvaliacaoTreinamentoLoteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/avaliacao-treinamento-lote`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllAvaliacaoTreinamentoLoteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async avaliarTreinamentoLote(
    request: AvaliarTreinamentoLoteRequest,
  ): Promise<AvaliarTreinamentoLoteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/avaliacao-treinamento-lote/avaliar`,
        request,
      );
      const response =
        handleAxiosResponse<AvaliarTreinamentoLoteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllTreinamentoFuncionario(
    request: GetAllTreinamentoFuncionarioRequest,
  ): Promise<GetAllTreinamentoFuncionarioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/treinamento-funcionario`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllTreinamentoFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async saveTreinamentoFuncionario(
    request: SaveTreinamentoFuncionarioRequest,
  ): Promise<SaveTreinamentoFuncionarioResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/rh/treinamento-funcionario/save`, formData, options);
      const response = handleAxiosResponse<SaveTreinamentoFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllTreinamentoFuncionarioData(
    _: GetAllTreinamentoFuncionarioDataRequest,
  ): Promise<GetAllTreinamentoFuncionarioDataResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/treinamento-funcionario/data`,
      );
      const response =
        handleAxiosResponse<GetAllTreinamentoFuncionarioDataResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllTreinamentoFuncionarioAssinatura(
    request: GetAllTreinamentoFuncionarioAssinaturaRequest,
  ): Promise<GetAllTreinamentoFuncionarioAssinaturaResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/treinamento-funcionario/assinatura`,
      );
      const response =
        handleAxiosResponse<GetAllTreinamentoFuncionarioAssinaturaResponse>(
          result,
        );
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllTreinamentoFuncionarioInstrutor(
    request: GetAllTreinamentoFuncionarioInstrutorRequest,
  ): Promise<GetAllTreinamentoFuncionarioInstrutorResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/treinamento-funcionario/instrutor/${request.data}`,
      );
      const response =
        handleAxiosResponse<GetAllTreinamentoFuncionarioInstrutorResponse>(
          result,
        );
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllTreinamentoFuncionarioLocal(
    request: GetAllTreinamentoFuncionarioLocalRequest,
  ): Promise<GetAllTreinamentoFuncionarioLocalResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/treinamento-funcionario/local`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllTreinamentoFuncionarioLocalResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllFolhaPagamento(
    request: GetAllFolhaPagamentoRequest,
  ): Promise<GetAllFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/folha-pagamento`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createFolhaPagamento(
    request: CreateFolhaPagamentoRequest,
  ): Promise<CreateFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/folha-pagamento/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateFolhaPagamento(
    request: UpdateFolhaPagamentoRequest,
  ): Promise<UpdateFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/folha-pagamento/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteFolhaPagamento(
    request: DeleteFolhaPagamentoRequest,
  ): Promise<DeleteFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/folha-pagamento/delete/${request.idFolhaPagamento}`,
      );
      const response =
        handleAxiosResponse<DeleteFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copyFolhaPagamento(
    request: CopyFolhaPagamentoRequest,
  ): Promise<CopyFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/folha-pagamento/copy`,
        request,
      );
      const response =
        handleAxiosResponse<DeleteFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFiltroFolhaPagamento(
    request: GetFiltroFolhaPagamentoRequest,
  ): Promise<GetFiltroFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).get(`/rh/filtro-folha-pagamento`);
      const response =
        handleAxiosResponse<GetFiltroFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createFiltroFolhaPagamento(
    request: CreateFiltroFolhaPagamentoRequest,
  ): Promise<CreateFiltroFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/filtro-folha-pagamento/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateFiltroFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllFolhaPagamentoItens(
    request: GetAllFolhaPagamentoItensRequest,
  ): Promise<GetAllFolhaPagamentoItensResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/item-folha-pagamento`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllFolhaPagamentoItensResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFolhaPagamento(
    request: GetFolhaPagamentoRequest,
  ): Promise<GetFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/folha-pagamento/${request.idFolhaPagamento}`,
      );
      const response = handleAxiosResponse<GetFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createItemFolhaPagamento(
    request: CreateItemFolhaPagamentoRequest,
  ): Promise<CreateItemFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/item-folha-pagamento/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateItemFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateItemFolhaPagamento(
    request: UpdateItemFolhaPagamentoRequest,
  ): Promise<UpdateItemFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/item-folha-pagamento/update`,
        request,
      );
      const response =
        handleAxiosResponse<DeleteItemFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteItemFolhaPagamento(
    request: DeleteItemFolhaPagamentoRequest,
  ): Promise<DeleteItemFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/item-folha-pagamento/delete/${request.idItemFolhaPagamento}`,
      );
      const response =
        handleAxiosResponse<DeleteItemFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFolhaPagamentoDetalhe(
    request: GetFolhaPagamentoDetalheRequest,
  ): Promise<GetFolhaPagamentoDetalheResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/folha-pagamento/detalhe/${request.idItemFolhaPagamento}`,
      );
      const response =
        handleAxiosResponse<GetFolhaPagamentoDetalheResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getItemFolhaPagamento(
    request: GetItemFolhaPagamentoRequest,
  ): Promise<GetItemFolhaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/rh/item-folha-pagamento/${request.idItemFolhaPagamento}`,
      );
      const response =
        handleAxiosResponse<GetItemFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteItemFolhaPagamentoVerba(
    request: DeleteItemFolhaPagamentoVerbaRequest,
  ): Promise<DeleteItemFolhaPagamentoVerbaResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/item-folha-pagamento-verba/delete/${request.idItemFolhaPagamentoVerba}`,
      );
      const response =
        handleAxiosResponse<DeleteItemFolhaPagamentoVerbaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllItemFolhaPagamentoVerba(
    request: GetAllItemFolhaPagamentoVerbaRequest,
  ): Promise<GetAllItemFolhaPagamentoVerbaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/item-folha-pagamento-verba`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllItemFolhaPagamentoVerbaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createItemFolhaPagamentoVerba(
    request: CreateItemFolhaPagamentoVerbaRequest,
  ): Promise<CreateItemFolhaPagamentoVerbaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/item-folha-pagamento-verba/create`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllItemFolhaPagamentoVerbaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateItemFolhaPagamentoVerba(
    request: UpdateItemFolhaPagamentoVerbaRequest,
  ): Promise<UpdateItemFolhaPagamentoVerbaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/item-folha-pagamento-verba/update`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllItemFolhaPagamentoVerbaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllVerbaPagamento(
    request: GetAllVerbaPagamentoRequest,
  ): Promise<GetAllVerbaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/verba-pagamento`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllVerbaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createVerbaPagamento(
    request: CreateVerbaPagamentoRequest,
  ): Promise<CreateVerbaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/verba-pagamento/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateVerbaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateVerbaPagamento(
    request: UpdateVerbaPagamentoRequest,
  ): Promise<UpdateVerbaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/verba-pagamento/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateVerbaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteVerbaPagamento(
    request: DeleteVerbaPagamentoRequest,
  ): Promise<DeleteVerbaPagamentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/verba-pagamento/delete/${request.idItemVerba}`,
      );
      const response =
        handleAxiosResponse<DeleteVerbaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async alterarCentroCustoFuncionarios(
    request: AlterarCentroCustoFuncionariosRequest,
  ): Promise<AlterarCentroCustoFuncionariosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/centro-custo/alterar`,
        request,
      );
      const response =
        handleAxiosResponse<AlterarCentroCustoFuncionariosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async downloadFuncionarioDocumentoById({
    idFuncionarioArquivo,
  }: DownloadFuncionarioDocumentoByIdRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: "blob" }).get(
        `/rh/funcionarios/documentos/${idFuncionarioArquivo}/download`,
      );
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async downloadControlePatrimonioById({
    idControlePatrimonio,
  }: DownloadControlePatrimonioByIdRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: "blob" }).get(
        `/rh/funcionarios/controle-patrimonios/${idControlePatrimonio}/download`,
      );
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getDashboardRhInformation(
    _: GetDashboardRhInformationRequest,
  ): Promise<GetDashboardRhInformationResponse> {
    try {
      const result = await axiosInstance({}).get(`/rh/dashboard/information`);
      const response =
        handleAxiosResponse<GetDashboardRhInformationResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getFuncionarioImageById({
    idFuncionario,
  }: GetFuncionarioImageByIdRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: "blob" }).get(
        `/rh/funcionarios/${idFuncionario}/imagem`,
      );
      return result.data as Blob;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteFuncionarioImageById({
    idFuncionario,
  }: DeleteFuncionarioImageByIdRequest): Promise<DeleteFuncionarioImageByIdResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/funcionarios/${idFuncionario}/imagem`,
      );
      const response =
        handleAxiosResponse<DeleteFuncionarioImageByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copyFuncionario(
    request: CopyFuncionarioRequest,
  ): Promise<CopyFuncionarioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/funcionarios/copy`,
        request,
      );
      const response = handleAxiosResponse<CopyFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async downloadFuncionarioAssinatura({
    idFuncionarioAssinatura,
  }: DownloadFuncionarioAssinaturaRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: "blob" }).get(
        `/rh/funcionarios/assinaturas/${idFuncionarioAssinatura}/download`,
      );
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createBiometriaFacial(
    request: CreateBiometriaFacialRequest,
  ): Promise<CreateBiometriaFacialResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/RegistrarGryfo`,
        request,
      );
      const response =
        handleAxiosResponse<CreateBiometriaFacialResponse>(result);
      console.log("response1", response);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createBiometriaFacialFuncionario(
    request: CreateBiometriaFacialFuncionarioRequest,
  ): Promise<CreateBiometriaFacialFuncionarioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/biometriaFacial/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateBiometriaFacialFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getBiometriaFacial(
    request: GetBiometriaFacialRequest,
  ): Promise<GetBiometriaFacialResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/biometriaFacial/list`,
        request,
      );
      const response = handleAxiosResponse<GetBiometriaFacialResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async inativarBiometriaFacial({
    idFuncionario,
  }: InativarBiometriaFacialRequest): Promise<InativarBiometriaFacialResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/rh/biometriaFacial/inativar/${idFuncionario}`,
      );
      const response = handleAxiosResponse<InativarBiometriaFacialResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getBiometriaFacialVisualizar({
    idBiometriaFacial,
  }: GetBiometriaFacialVisualizarRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: "blob" }).get(
        `/rh/biometriaFacial/visualizar/${idBiometriaFacial}`,
      );
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createTermoBiometria(
    request: CreateTermoBiometriaRequest): Promise<void> {
    try {
      const result = await axiosInstance({}).post(
        `/rh/termobiometria/create`,
        request,
      );
      const response = handleAxiosResponse<void>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async generateCertificate({ idFuncionarioTreinamento, ...request }: GenerateCertificateRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: "blob" }).post(`/rh/funcionarios-treinamentos/${idFuncionarioTreinamento}/certificado`, request);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof Blob) {
        throw toBaseError(JSON.parse(await error.text()));
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
}
